"use strict";
exports.__esModule = true;
exports.makeOpaque = void 0;
// Use common function to cast and make data opaque in the app vs placing eslint-disable-everywhere
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types,@typescript-eslint/consistent-type-assertions
var makeOpaque = function (someData) {
    return someData;
};
exports.makeOpaque = makeOpaque;
//# sourceMappingURL=index.js.map